// src/pages/cashier/LoungeCashierDashboard.jsx
import React from 'react';
import CashierDashboard from '../CashierDashboard';

const LoungeCashierDashboard = () => {
  return <CashierDashboard locationKey="lounge" />;
};

export default LoungeCashierDashboard;